"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiPhonePicker = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _multiPhonePickerModule = _interopRequireDefault(require("./multi-phone-picker.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _useTranslation2 = require("../../../hooks/useTranslation/useTranslation");
var _remove = require("../../../assets/icons/remove.svg");
var _plusCircled = require("../../../assets/icons/plus-circled.svg");
var _PhonePicker = require("../phone-picker/PhonePicker");
var _FormField = require("../../form-field/FormField");
var ADDITIONAL_PHONE_NUMBERS_LENGTH = 10;
var MultiPhonePickerTrigger = function MultiPhonePickerTrigger(_ref) {
  var onClick = _ref.onClick,
    className = _ref.className,
    label = _ref.label;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: onClick,
    className: (0, _classnames.default)(_multiPhonePickerModule.default['multi-phone-picker__add-new'], className)
  }, /*#__PURE__*/_react.default.createElement(_plusCircled.ReactComponent, {
    className: _multiPhonePickerModule.default['multi-phone-picker__add-icon']
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: _multiPhonePickerModule.default['multi-phone-picker__add-new-label']
  }, label ? label : t('multiPhonePicker.addNewLabel')));
};
var MultiPhonePicker = function MultiPhonePicker(_ref2) {
  var id = _ref2.id,
    name = _ref2.name,
    value = _ref2.value,
    onChange = _ref2.onChange,
    className = _ref2.className,
    getError = _ref2.getError,
    required = _ref2.required,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    placeholder = _ref2.placeholder,
    searchPlaceholder = _ref2.searchPlaceholder,
    noCountriesText = _ref2.noCountriesText,
    addNewLabel = _ref2.addNewLabel;
  var _useState = (0, _react.useState)(value ? value : []),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedValue = _useState2[0],
    setSelectedValue = _useState2[1];
  (0, _react.useEffect)(function () {
    setSelectedValue(value ? value : []);
  }, [value]);
  var handleOnChange = function handleOnChange(index, value) {
    var newValue = (0, _toConsumableArray2.default)(selectedValue);
    newValue[index] = value;
    setSelectedValue(newValue);
    onChange(newValue);
  };
  var handleAddNew = function handleAddNew() {
    var newValue = [].concat((0, _toConsumableArray2.default)(selectedValue), [{
      number: '',
      countryCode: '44',
      key: 'GB'
    }]);
    setSelectedValue(newValue);
    onChange(newValue);
  };
  var handleRemove = function handleRemove(index) {
    var newValue = (0, _toConsumableArray2.default)(selectedValue);
    newValue.splice(index, 1);
    setSelectedValue(newValue);
    onChange(newValue);
  };
  var renderPickers = function renderPickers() {
    return selectedValue.map(function (value, index) {
      var error = getError(index);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _multiPhonePickerModule.default['multi-phone-picker__error-container'],
        key: "phone-picker-".concat(index)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _multiPhonePickerModule.default['multi-phone-picker__input-container'],
        "data-testid": "phone-picker-input-container-".concat(index)
      }, /*#__PURE__*/_react.default.createElement(_PhonePicker.PhonePicker, {
        id: "".concat(id, "-").concat(index),
        "data-testid": "".concat(id, "-").concat(index),
        name: "".concat(name, "-").concat(index),
        className: _multiPhonePickerModule.default['multi-phone-picker__input'],
        onChange: function onChange(value) {
          return handleOnChange(index, value);
        },
        value: value,
        error: !!error,
        required: required,
        disabled: disabled,
        placeholder: placeholder,
        searchPlaceholder: searchPlaceholder,
        noCountriesText: noCountriesText
      }), !disabled && /*#__PURE__*/_react.default.createElement(_remove.ReactComponent, {
        "data-testid": "clear-icon-".concat(index),
        className: _multiPhonePickerModule.default['multi-phone-picker__clear-icon'],
        onClick: function onClick() {
          return handleRemove(index);
        }
      })), /*#__PURE__*/_react.default.createElement(_FormField.FormFieldMessage, {
        submitted: !!error,
        errorMessage: error
      }));
    });
  };
  var shouldDisplayAddNew = !disabled && selectedValue.length >= 0 && selectedValue.length < ADDITIONAL_PHONE_NUMBERS_LENGTH;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": 'multi-phone-picker__container',
    className: (0, _classnames.default)(_multiPhonePickerModule.default['multi-phone-picker__container'], className)
  }, renderPickers(), shouldDisplayAddNew && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(MultiPhonePickerTrigger, {
    onClick: handleAddNew,
    label: addNewLabel
  })));
};
exports.MultiPhonePicker = MultiPhonePicker;
MultiPhonePicker.Trigger = MultiPhonePickerTrigger;